// Meta Pixel utilities
// Pixel ID for "Ciclo en Calma"
export const META_PIXEL_ID = '3242823375894018'

declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

let initialized = false

/**
 * Loads the Meta Pixel base code into the page and fires a PageView.
 * Safe to call multiple times — will only initialize once.
 * Wrapped in try/catch so a pixel failure can NEVER take down the app.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  try {
    // Standard Meta Pixel snippet, hardened:
    // - Appends to <head> instead of using insertBefore on a "first script" tag,
    //   because in some bundled / iframe environments getElementsByTagName('script')[0]
    //   returns undefined and crashes with "Cannot read properties of undefined (reading 'parentNode')".
    /* eslint-disable */
    ;(function (f: any, b: Document, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        // @ts-ignore
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement('script') as HTMLScriptElement
      t.async = true
      t.src = v
      // Resilient injection: head if available, else body, else first script.
      const target = b.head || b.body
      if (target) {
        target.appendChild(t)
      } else {
        const s = b.getElementsByTagName('script')[0]
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        }
      }
    })(window, document, 'https://connect.facebook.net/en_US/fbevents.js')
    /* eslint-enable */

    window.fbq?.('init', META_PIXEL_ID)
    window.fbq?.('track', 'PageView')
  } catch (err) {
    // Never let analytics take down the page.
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] init failed:', err)
  }
}

/**
 * Fires a Meta Pixel event. Use one of the standard event names
 * (e.g. 'AddToCart', 'InitiateCheckout', 'Purchase').
 */
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined') return
  try {
    if (params) {
      window.fbq?.('track', eventName, params)
    } else {
      window.fbq?.('track', eventName)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[MetaPixel] track failed:', err)
  }
}
